import React from 'react';

const AboutUs = () => (
	<div className="container main">
		<h2>About us</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>OECD Working Party on Consumer Product Safety</h4>
				<p>
					The GlobalRecalls Portal was developed by the <a href="http://www.oecd.org/sti/consumer/consumer-product-safety.htm">OECD Working Party on Consumer Product Safety</a>.
					Its mandate focuses on improving information sharing and promoting greater co-operation among product safety market surveillance, enforcement, and regulatory authorities worldwide by:
				</p>
				<ul className={'rss-feed-options'}>
					<li>Identifying safety issues early</li>
					<li>Sharing practices and policy law developments</li>
					<li>Addressing safety concerns in a consistent way</li>
					<li>Supporting global and regional fora</li>
				</ul>
				<p>
					One of the Working Party’s key achievements is the <a href="https://legalinstruments.oecd.org/en/instruments/OECD-LEGAL-0459">OECD Recommendation on Consumer Product Safety</a>, which outlines
					the core principles that should be at the heart of consumer product safety frameworks at domestic and international level and encourages further use of the GlobalRecalls Portal.
					The Working Party has also developed a large number of other resources for governments and businesses on more effective product recalls, which can be found on its <a href="https://www.oecd.org/digital/consumer/consumer-product-safety.htm">website</a>.
				</p>
			</div>
			<div className="col-sm-6">
				<h4 className="hidden-xs">&nbsp;</h4>
				<p>
					The Working Party falls under the responsibility of the <a href="https://www.oecd.org/sti/consumer/">OECD Committee on Consumer Policy</a> and both bodies regularly work together on related consumer protection issues, with many joint projects and events.
				</p>
				<p>
					The Working Party also co-operates closely with international organisations that are active in product safety,
					including the Association of Southeast Asian Nations (ASEAN), the European Commission (EC), the International Consumer Protection Enforcement Network (ICPEN),
					the International Consumer Policy Health & Safety Organization (ICPHSO), the Organization of American States (OAS) and the United Nations Committee for Trade and Development (UNCTAD).
					The Working Party also retains close ties with a number of OECD Partner economies.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Contact us</h4>
				<p>
					Should you have any questions or comments on the <em>GlobalRecalls</em> portal, please contact the OECD Secretariat: <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>
				</p>
			</div>
		</div>
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/views/static/en/about-us.js